import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function AdminPromptsPage() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name: "", version: "v1", description: "", system_prompt: "", user_prompt_template: "", active: true });
  const upd = (k, v) => setForm(s => ({ ...s, [k]: v }));
  const load = () => api.get("/admin/prompts").then(r => setItems(r.data || [])).catch(() => toast.error("Owner-only"));
  useEffect(() => { load(); }, []);
  const add = async () => { try { await api.post("/admin/prompts", form); toast.success("Added"); load(); } catch { toast.error("Add failed"); } };
  return (
    <AdminLayout>
      <div className="kicker">Owner only</div>
      <h1 className="mt-1 font-serif text-3xl font-semibold">Prompt templates</h1>
      <p className="mt-2 text-sm text-muted-foreground">Manage the AI editorial prompts. Only owners can modify.</p>

      <Card className="mt-6 p-6">
        <div className="kicker">Add template</div>
        <div className="mt-3 grid gap-3">
          <Input placeholder="Name" value={form.name} onChange={e => upd("name", e.target.value)} className="h-11" />
          <Input placeholder="Version" value={form.version} onChange={e => upd("version", e.target.value)} className="h-11 font-mono text-sm" />
          <Input placeholder="Description" value={form.description} onChange={e => upd("description", e.target.value)} className="h-11" />
          <Textarea placeholder="System prompt" rows={6} value={form.system_prompt} onChange={e => upd("system_prompt", e.target.value)} />
          <Textarea placeholder="User prompt template" rows={6} value={form.user_prompt_template} onChange={e => upd("user_prompt_template", e.target.value)} />
        </div>
        <div className="mt-3"><Button onClick={add} className="bg-[color:var(--coh-ink)] text-white">Add</Button></div>
      </Card>

      <div className="mt-6 space-y-3">
        {items.length === 0 && <Card className="p-6 text-sm text-muted-foreground">No templates yet.</Card>}
        {items.map((p) => (
          <Card key={p.id} className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <div className="font-medium">{p.name} <span className="text-xs font-mono text-muted-foreground ml-2">{p.version}</span></div>
                <div className="text-xs text-muted-foreground">{p.description}</div>
              </div>
              <div className="text-xs text-muted-foreground">{p.active ? "Active" : "Inactive"}</div>
            </div>
          </Card>
        ))}
      </div>
    </AdminLayout>
  );
}
